import type { FC, ReactNode } from 'react'
import type { ProgramRequest } from '@/types'

import { useState } from 'react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import HighlightsSection from '@/components/landing/highlights-section'
import ProgramsSection from '@/components/landing/programs-section'
import AboutSection from '@/components/landing/about-section'
import PortalSection from '@/components/landing/portal-section'
import CentersSection from '@/components/landing/centers-section'
import FaqSection from '@/components/landing/faq-section'
import RegisterSection from '@/components/landing/register-section'

const SHARE_IMAGE = 'https://webify-academic-portal.cdn.modulify.website/images/share/webify-share.jpg'

const Home: FC = (): ReactNode => {
    const [programRequest, setProgramRequest] = useState<ProgramRequest | null>(null)

    const handleSelectProgram = (id: string): void => {
        setProgramRequest((current) => ({ id, key: (current?.key ?? 0) + 1 }))
    }

    return (
        <Layout>
            <Seo ogImage={SHARE_IMAGE} />

            <HeroSection />
            <HighlightsSection />
            <ProgramsSection onSelectProgram={handleSelectProgram} />
            <AboutSection />
            <PortalSection />
            <CentersSection />
            <FaqSection />
            <RegisterSection programRequest={programRequest} />
        </Layout>
    )
}

export default Home
